import { channelStatus } from '@/mocks/homeData';

export default function StatusStrip() {
  return (
    <section id="status" className="w-full scroll-mt-24 border-b border-background-200/70 bg-background-100/80">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-3 px-4 py-4 md:flex-row md:items-center md:justify-between md:px-6">
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-600 md:text-sm">
          <span className="inline-flex items-center gap-2 font-medium text-foreground-900">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75" />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary-500" />
            </span>
            通道监测中
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-accent-500" />
            正常 {channelStatus.online} 条
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-error-warning-fill text-secondary-500" />
            备用 {channelStatus.backup} 条
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-tools-fill text-foreground-400" />
            维护 {channelStatus.maintenance} 条
          </span>
        </div>
        <span className="text-xs text-foreground-500">最近更新：{channelStatus.updatedAt}</span>
      </div>
    </section>
  );
}